// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2UiP3","image":"Header_image__r_Gz2","name":"Header_name__32ymh","info":"Header_info__2f0-_","infoRow":"Header_infoRow__2z_Ho"};